<template>
    <div class="numBox">
        <div class="firstNum">
            <hd-num v-model="cje" :title="title" :actClass="'firstCls'" :decSymClass="'dot'" :newClass="'newclass'" style="margin-top: 30px" :numBgClass="'firstCls'"> </hd-num>
            <img class="board" src="../../assets/img/board.png" alt="" />
        </div>
    </div>
</template>

<script>
import hdNum from '../../components/trunNum.vue';
export default {
    props: {
        cje: {
            type: Number,
            default: 0
        },
        cjl: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            count: 0
        };
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {},
    methods: {},
    components: {
        hdNum
    }
};
</script>
<style scoped lang="scss">
.numBox {
    margin-top: 40px;
    .board {
        margin: auto;
        margin-top: -30px;
        display: block;
        width: 766px;
        height: 60px;
    }
}
</style>
